module.exports = __webpack_public_path__ + "img/pr-17.783c9f21.png";